import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CreatePlaylistModalTrigger from './CreatePlaylistModalTrigger';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const CardMenuAddToNewPlaylistOption = ({
  item
}) => {
  return /*#__PURE__*/_jsx(CreatePlaylistModalTrigger, {
    item: item,
    renderTrigger: ({
      openModal
    }) => /*#__PURE__*/_jsx(SideNavItem, {
      onClick: () => {
        UsageTracker.trackStandalone('Playlist Interaction', {
          action: 'add-to-new-playlist',
          location: 'card-menu',
          itemId: item.id,
          itemType: item.type,
          visibility: item.visibility ? readUnhandledEnumCase(item.visibility) : undefined
        });
        openModal();
      },
      role: "navigation-item",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.cardMenu.addToNewPlaylist"
      })
    })
  });
};
export default CardMenuAddToNewPlaylistOption;